<template>
  <Skeleton v-if="!mounted" height="40px" width="95.27px" class="margin-left-xs" />
  <button v-else class="rail-btn-hover rail-btn-nowrap margin-left-xs" @click.prevent="openInternationalSlideout">
    <Flag width="28px" height="28px" :title-builder="titleBuilder" />
  </button>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { useMounted } from '@vueuse/core';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import useInternationalSlideout from '~/composables/features/useInternationalSlideout';
import Flag from '~/components/common/Flag.common';

const mounted = useMounted();
const { openInternationalSlideout } = useInternationalSlideout();
const titleBuilder = (regionCode) => `Shipping to ${regionCode}`;
</script>
